<template>
  <div style="position: relative;min-height: 200px">
    <v-container>
      <div v-if="loading" class="text-xs-center">
        <v-progress-circular :size="70" color="primary" indeterminate></v-progress-circular>
      </div>
      <template v-else>
        <v-text-field
          name="Search"
          label="Search"
          v-model="search"
          clearable
          single-line
          prepend-inner-icon="search"
          outline
        ></v-text-field>
        <template v-for="flow in filterFlows">
          <div class="z-border-red mb-2 pa-2" :key="flow.id">
            <add-flow :value="flow" @onSave="onEdit" @onDelete="onDelete(flow.id)"></add-flow>
          </div>
        </template>
        <div
          class="add-conversation text-xs-center"
          style="cursor: pointer"
          @click="isAdd = true"
          v-if="!isAdd"
        >
          <i class="fa fa-plus middle"></i>
          {{ $t('Add flow') }}
        </div>
        <div class="z-border-red mb-2 pa-2" v-else>
          <add-flow @onCancel="isAdd = false" @onSave="onSave"></add-flow>
        </div>
      </template>
    </v-container>
  </div>
</template>

<script>
import api from '@/api'
import { mapGetters, mapMutations } from 'vuex'
import AddFlow from './AddFlow'
export default {
  data() {
    return {
      isAdd: false,
      loadingAddFlow: false,
      search: ''
    }
  },
  components: {
    AddFlow
  },
  computed: {
    ...mapGetters({
      selectedBot: 'selectedBot',
      flows: 'getFlowList',
      loading: 'getLoadingFlowList',
      selectedFlow: 'getFlowId'
    }),
    filterFlows() {
      let flows = this.flows
      if(this.search) {
        flows = flows.filter(el => {
          return el.flowname && el.flowname.toLowerCase().includes(this.search.toLowerCase())
        })
      }
      return flows
    }
  },
  methods: {
    async onEdit(payload) {
      // editFlowDetail
      var vm = this
      this.isAdd = false

      var data = payload
      vm.loadingAddFlow = true
      try {
        var response = await api.editFlowDetail(data)

        await vm.$store.dispatch('loadFlowList')
        if (this.selectedFlow && this.selectedFlow.id == payload.id) {
          if(response.data && response.data.length > 0) {
            this.$store.dispatch('setFlowID', response.data[0])
          }
        }
        vm.loadingAddFlow = false
      } catch (error) {
        vm.loadingAddFlow = false
      }
    },
    async onSave(payload) {
      var vm = this
      this.isAdd = false

      var data = {
        ...payload,
        flowname: payload.flowname,
        x: 0,
        y: 0,
        zoom: 1,
        adminid: vm.$store.state.userid,
        template: payload.template && payload.template != '' ? payload.template : null
      }
      vm.loadingAddFlow = true
      try {
        var response = await api.addFlowDetail(data)

        await vm.$store.dispatch('loadFlowList')

        vm.loadingAddFlow = false
      } catch (error) {
        vm.loadingAddFlow = false
      }
    },
    async onDelete(id) {
      var vm = this
      var result = await vm.$swal.fire({
        title: vm.$t('Do you want to delete this?'),
        type: 'question',
        showCancelButton: true,
        confirmButtonText: vm.$t('Confirm'),
        cancelButtonText: vm.$t('cancel'),
        reverseButtons: true
      })

      if (result.value) {
        vm.loadingAddFlow = true
        var data = {
          id: id
        }
        try {
          var response = await api.deleteFlowDetail(data)

          await vm.$store.dispatch('loadFlowList')
          if (this.flows.length > 0 && this.selectedFlow.id == id) {
            this.$store.dispatch('setFlowID', this.flows[0])
          }
          vm.loadingAddFlow = false
        } catch (error) {
          vm.loadingAddFlow = false
        }
      }
    }
  }
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/view/flow/FlowSetting.vue